export const Dashboard = {
    SET_SUMMARY: "dashboard.set_summary",
    SET_MARKET_BREAKDOWN: "dashboard.set_market_breakdown",
    SET_LOADING: "dashboard.set_loading",
    SET_ERROR: "dashboard.set_error",
};
